import { isHR, isHRAdmin } from '@/old/utils/helper';

export const canManagePublicReportSettings = (): boolean => isHRAdmin() || isHR();
